import React, { useState } from 'react';
import { MapPin, X, ShoppingCart, Users, Maximize } from 'lucide-react';
import { useCart } from '../../../context/CartContext';
import './LocationCard.css';

const LocationCard = ({ location }) => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    addToCart({
      id: location.id,
      type: 'location',
      name: location.name,
      price: location.price,
      data: location,
      image: location.images?.[0],
    });
    setShowModal(false);
  };

  const mainImage = location.images?.[0] || '';

  return (
    <>
      {/* Card */}
      <div className="location-card" onClick={() => setShowModal(true)}>
        <div className="loc-card-image">
          {mainImage ? (
            <img src={mainImage} alt={`${location.name} - Filming location in ${location.city || 'Chicago'}`} />
          ) : (
            <div className="loc-card-placeholder">
              <MapPin size={40} />
            </div>
          )}
        </div>
        <div className="loc-card-content">
          <h3 className="loc-card-title">{location.name}</h3>
          <p className="loc-card-location">
            <MapPin size={14} />
            {location.city}, {location.state}
          </p>
          <div className="loc-card-details">
            <span className="loc-detail">
              <Maximize size={14} />
              {location.size}
            </span>
            <span className="loc-detail">
              <Users size={14} />
              {location.capacity}
            </span>
          </div>
          <div className="loc-card-footer">
            <span className="loc-card-price">${location.price}/day</span>
            <span className="loc-card-link">View Details →</span>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="loc-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="loc-modal" onClick={(e) => e.stopPropagation()}>
            <button className="loc-modal-close" onClick={() => setShowModal(false)}>
              <X size={24} />
            </button>

            <div className="loc-modal-grid">
              {/* Image Gallery */}
              <div className="loc-modal-images">
                {location.images && location.images.length > 0 ? (
                  <div className="loc-images-grid">
                    {location.images.map((img, index) => (
                      <img key={index} src={img} alt={`${location.name} ${index + 1}`} />
                    ))}
                  </div>
                ) : (
                  <div className="loc-modal-placeholder">
                    <MapPin size={64} />
                  </div>
                )}
              </div>

              {/* Details */}
              <div className="loc-modal-details">
                <h2 className="loc-modal-title">{location.name}</h2>
                
                <p className="loc-modal-location">
                  <MapPin size={16} />
                  {location.address && `${location.address}, `}
                  {location.city}, {location.state} {location.zipCode}
                </p>

                <div className="loc-modal-info">
                  <div className="loc-info-row">
                    <span className="loc-info-label">Size:</span>
                    <span className="loc-info-value">{location.size}</span>
                  </div>
                  <div className="loc-info-row">
                    <span className="loc-info-label">Capacity:</span>
                    <span className="loc-info-value">{location.capacity}</span>
                  </div>
                </div>

                {location.description && (
                  <div className="loc-modal-description">
                    <h4>Description</h4>
                    <p>{location.description}</p>
                  </div>
                )}

                {location.amenities && location.amenities.length > 0 && (
                  <div className="loc-modal-amenities">
                    <h4>Amenities</h4>
                    <div className="loc-amenities-list">
                      {location.amenities.map((amenity, index) => (
                        <span key={index} className="loc-amenity-tag">{amenity}</span>
                      ))}
                    </div>
                  </div>
                )}

                <div className="loc-modal-actions">
                  <div className="loc-modal-price">
                    <span className="loc-price-label">Daily Rate</span>
                    <span className="loc-price-value">${location.price}</span>
                  </div>
                  <button 
                    onClick={handleAddToCart}
                    className="btn btn-primary"
                  >
                    <ShoppingCart size={18} />
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LocationCard;